import script from "./ChargeTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./ChargeTemplate.vue?vue&type=script&setup=true&lang=js"

import "./ChargeTemplate.vue?vue&type=style&index=0&id=6e28a7a1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e28a7a1"]])

export default __exports__